<template>
  <aside class="flex h-full flex-col p-1 space-y-3 bg-primary-500 px-2 w-20">
    <div class="flex h-16 shrink-0 items-center justify-center">
      <button
        class="flex gap-1.5 text-xl font-bold px-2 py-1 items-center"
        @click="$router.push('/')"
      >
        <ComplianceIcon class="text-white" />
      </button>
    </div>

    <div class="space-y-1 mt-2 items-center justify-center">
      <router-link
        to="/compliance"
        :class="[
          'rounded-lg hover:bg-primary-50 hover:text-primary-500 p-3 flex gap-2 items-center justify-center',
          isActive('/compliance')
            ? 'bg-primary-50 text-primary-500'
            : 'text-white',
        ]"
      >
        <span class="material-symbols-outlined">stacks</span>
      </router-link>

      <router-link
        to="/operators"
        :class="[
          'rounded-lg hover:bg-primary-50 hover:text-primary-500 p-3 flex gap-2 items-center justify-center',
          isActive('/operators')
            ? 'bg-primary-50 text-primary-500'
            : 'text-white',
        ]"
      >
        <span class="material-symbols-outlined">corporate_fare</span>
      </router-link>
    </div>

    <hr class="border-t border-primary-400" />
  </aside>
</template>

<script lang="ts" setup>
import ComplianceIcon from "components/icons/ComplianceIcon.vue";
import { useRoute } from "vue-router";

const route = useRoute();
function isActive(routePath: string) {
  return route.path.includes(routePath);
}
</script>
